export enum ToggleNameEnum {
  ActivityCardAddress = 'activity_card_address',
  ActivityCardRating = 'activity_card_rating',
  ActivityCardTimeslots = 'activity_card_timeslots',
  ActivityCreationBirthdayType = 'activity_creation_birthday_type',
  ActivityCreationBookableUntilTheEnd = 'activity_creation_bookable_until_the_end',
  ActivityCreationGroupLessonType = 'activity_creation_group_lesson_type',
  ActivityCreationLiveType = 'activity_creation_live_type',
  ActivityCreationMultiDayCourseType = 'activity_creation_multi_day_course_type',
  ActivityCreationEvent = 'activity_creation_event_type',
  ActivityCreationMultiplePlans = 'activity_creation_multi_plans',
  ActivityCreationPhotoExample = 'activity_creation_photo_example',
  ActivityCreationPlaygroundRentType = 'activity_creation_playground_rent_type',
  ActivityCreationProductTest = 'activity_creation_test_type',
  ActivityCreationProficiencyLevel = 'activity_creation_proficiency_level',
  ActivityCreationTimeslotsLimit = 'activity_creation_timeslots_limit',
  ActivityCreationWorkshopType = 'activity_creation_workshop_type',
  ActivityEditionOffersAndOptions = 'activity_edition_offers_and_options',
  ActivityFreeOnly = 'activity_free_only',
  ActivityHeaderRating = 'activity_header_rating',
  ActivityLiveConnectionDetails = 'activity_live_connection_details',
  ActivityLoyaltyPoints = 'activity_loyalty_points',
  ActivityManagementCancel = 'activity_management_cancel',
  ActivityManagementDuplication = 'activity_management_duplication',
  ActivityManagementPreSchedule = 'activity_management_pre_schedule',
  ActivityRatingReport = 'activity_rating_report',
  ActivityRatingTranslate = 'activity_rating_translate',
  ActivityReview = 'activity_review',
  ActivityTitleMaximumLength = 'activity_title_maximum_length',
  ActivityResultsIncludeNextDates = 'attendee.result_page.include_next_dates',
  AttendeeResultsExternalActivitiesTab ='attendee.result_page.tab_bar.external_activities',
  AgeFilter = 'age_filter',
  AllowExternalPayment = 'allow_external_payment',
  AudienceAll = 'audience_all',
  AutocompleteAllowedTypes = 'google_autocomplete_types',
  BookingDelay = 'booking_delay',
  BookingLimit = 'booking_limit',
  Countries = 'countries',
  CountriesAddressRegionField = 'countries_address_region_field',
  CountriesWebforms = 'countries_webforms',
  Currency = 'currency',
  DateFilter = 'date_filter',
  DecatClubUrl = 'decat_club_url',
  DefaultPaidOfferName = 'default_paid_offer',
  DisplayAttendeePhoneNumber = 'display_attendee_phone_number',
  EnableAroundMeSearch = 'enable_around_me_search',
  EnableOnePay = 'onepay',
  EnableRadiusSearch = 'enable_radius_search',
  ExcludedSports = 'excluded_sports',
  ExcludedSportsGroups = 'excluded_sports_groups',
  GlobalSocialMedias = 'global_social_medias',
  GoogleTagManager = 'google_tag_manager',
  IgnorePriceValidationWithoutPaymentProvider = 'ignore_price_validation_without_payment_provider',
  BmsCartLimit = 'bms_cart_limit',
  LegalTermsUsageUrl = 'legal_terms_usage_url',
  LegalTermsUsageParticipantUrl = 'legal_terms_usage_participant_url',
  LegalTermsUsageLinkDisplay = 'legal_terms_usage_link_display',
  LegalTermsSalesUrl = 'legal_terms_sales_url',
  LocalesLanguagesList = 'locales_languages_list',
  MajorityAge = 'majority_age',
  MultibookingCartLimit = 'multibooking_cart_limit',
  MultibookingSingleActivity = 'multibooking_single_activity',
  OneBookingWidget = 'onebooking_widget',
  OrganizationRating = 'organization_rating',
  OrganizationsDataStorage = 'organizations_data_storage',
  OrganizerActivityHasUrlPassword = 'organizer_activity_has_url_password',
  OrganizerDashboardAccess = 'organizer_dashboard_access',
  OrganizerDashboardMaintenance = 'organizer_dashboard_maintenance',
  OrganizerDisplayProfilUrl = 'organizer_display_profil_url',
  OrganizerInvoicesLink = 'organizer_invoices_link',
  OrganizerLoginMenuInternalLeaveUrl = 'organizer_login_menu_internal_leave_url',
  OrganizerMaxRecurrenceScheduleMonths = 'organizer_max_recurrence_schedule_months',
  OrganizerPageDescriptionReview = 'organizer_page_description_review',
  OrganizerPageTabs = 'organizer_page_tabs',
  OrganizerPreviewNewTab = 'organizer_preview_new_tab',
  OrganizerProfileViewLink = 'organizer_profile_view_link',
  OrganizerShareActivity = 'organizer_share_activity',
  OrganizerSharedGuardActivityByTypeMandatoryFields = 'shared_organizer_guard_activity_by_type_mandatory_fields',
  OrganizerSharedGuardActivityMandatoryFields = 'shared_organizer_guard_activity_mandatory_fields',
  OrganizerSharedGuardOrganizationMandatoryFields = 'shared_organizer_guard_organization_mandatory_fields',
  OrganizerTalkJsConversationSubject = 'organizer_talkjs_conversation_subject',
  OrganizerUpdatePartnerProfile = 'organizer_update_partner_profile_button',
  OrganizerUploadDocument = 'organizer_upload_document',
  PartnerDashboardUrl = 'partner_dashboard_url',
  PartnerRedirection = 'partner_redirection',
  PaymentProvider = 'payment_provider',
  PreBooking = 'pre_booking',
  PriceFilter = 'price_filter',
  PrintAttendees = 'print_attendees',
  PrivacyPolicyUrl = 'privacy_policy_url',
  PromoCode = 'promo_code',
  QrCode = 'qr_code',
  RadiusDistanceUnit = 'Radius_distance_unit',
  RefundTimeLimit = 'refund_time_limit_by_activity_type',
  ShowFullActivities = 'show_full_activities',
  SkipOfferNameSlugify = 'skip_offer_name_slugify',
  SportsListStorage = 'sports_list_storage',
  TaxExcluded = 'tax_excluded',
  TimeslotEditionGroupSize = 'timeslot_edition_group_size',
  TimeslotManagementCancel = 'timeslot_management_cancel',
  TimezoneSelection = 'timezone_selection',
  TipsSearchActivities = 'tips.search.activities',
  TipsSearchActivitiesLive = 'tips.search.activities_live',
  TipsSearchAdvice = 'tips.search.advice',
  ValidatorPhoneNumber = 'validator.phone_number',
  ValidatorPostalCode = 'validator.postal_code',
  IsVatDisplayed = 'price_vat',
}
